import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Fade, IconButton, IconButtonProps } from '@mui/material';
import { MouseEvent, useEffect, useState } from 'react';

export const CopyButton = ({ text, sx, ...props }: { text: string } & IconButtonProps) => {
    const [copied, setCopied] = useState(false);
    const [showCopied, setShowCopied] = useState(false);

    function onCopyClick(e: MouseEvent) {
        navigator.clipboard.writeText(text);
        setCopied(true);
        e.stopPropagation();
    }

    useEffect(() => {
        if (!copied) return;

        setCopied(false);
        setShowCopied(true);

        setTimeout(() => setShowCopied(false), 3000);
    }, [copied]);

    return (
        <IconButton onClick={onCopyClick} sx={{ p: 0.75, my: -1, ...sx }} {...props}>
            <Fade in={!showCopied} timeout={{ enter: 500, exit: 300 }}>
                <ContentCopyIcon fontSize="small" />
            </Fade>
            <Fade in={showCopied} timeout={{ enter: 0, exit: 500 }}>
                <CheckIcon
                    color="success"
                    sx={{
                        position: 'absolute',
                    }}
                />
            </Fade>
        </IconButton>
    );
};
